<template>
  <WrappingComponent :settings="settings" :formData="form" />
</template>

<script>
export default {
  name: "Services",
  props: {
    settings: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    WrappingComponent: () => import("./WrappingComponent")
  },

  data() {
    return {
      form: {
        feature_a_header: "",
        feature_a_text: "",
        feature_b_header: "",
        feature_b_text: "",
        feature_c_header: "",
        feature_c_text: "",
        feature_d_header: "",
        feature_d_text: ""
      }
    };
  }
};
</script>
